
import React from 'react'
import Icon from 'react-icon-base'

const FaPlus = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m35.9 16.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-9.3v9.2q0 0.9-0.6 1.6t-1.5 0.6h-4.3q-0.9 0-1.5-0.6t-0.7-1.6v-9.2h-9.3q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h9.3v-9.3q0-0.9 0.7-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.6 1.5v9.3h9.3q0.9 0 1.5 0.6t0.6 1.5z"/></g>
    </Icon>
)

export default FaPlus



// WEBPACK FOOTER //
// ./~/react-icons/fa/plus.js